import groq from 'groq'
import pageFields from '../fields/page'
import imageField from '../fields/image'
import mediaField from '../fields/media'

export default (slug, id) => {
  let query
  if (id) {
    query = `_id == "${id}"`
  } else {
    query = `_type == "signUp" && slug.current == "${slug}"`
  }
  return groq`
    *[${query}][0]{
      ...${pageFields},
      listId,
      intro,
      whatYouGetTitle,
      whatYouGet[]{
        thumbnail{
          ...${imageField}
        },
        heading1,
        heading2
      },
      splash{
        ...${mediaField}
      }
    }
  `
}
